import React, { useState } from "react";
import { collection, query, where, getDocs, updateDoc, doc } from "firebase/firestore";
import db from "./Firebase";
import Swal from "sweetalert2"
import moment from "moment-timezone";

const users_data = [

]; // ✅ Only update these users



const UpdateCourse = () => {
    const [loading, setLoading] = useState(false);

    const updateLessonTimes = async () => {
        setLoading(true);

        try {
            // ✅ Step 1: Query Firestore for only the specific users in users_data
            const q = query(
                collection(db, "nv_enrolled_courses"),
                where("course_name", "==", "Trouser Making Masterclass") // ✅ Filter by phone numbers
            );

            const querySnapshot = await getDocs(q);

            if (querySnapshot.empty) {
                Swal.fire("Error", "No matching enrolled users found!", "error");
                setLoading(false);
                return;
            }

            let updatedCount = 0;

            // ✅ Step 2: Loop through filtered users and update their lessons
            for (const courseDoc of querySnapshot.docs) {
                const courseRef = doc(db, "nv_enrolled_courses", courseDoc.id);
                const courseData = courseDoc.data();

                // // // ✅ Step 3: Convert IST time correctly
                // const startTimeIST = moment.tz("2025-06-13 15:00:00", "Asia/Kolkata").toDate(); // ✅ 4:00 PM IST
                // const endTimeIST = moment.tz("2025-06-13 17:00:00", "Asia/Kolkata").toDate();   // ✅ 5:00 PM IST

                // ✅ Step 4: Update only the first lesson's `start_on` & `end_on`
                const updatedLessons = courseData.lessons.map((lesson, index) =>
                    index === 4 // ✅ Only update the first lesson
                        ? {
                            ...lesson,
                            // lesson: "Course Recap and Q & A",
                            is_online: "no",
                            is_video: 'yes',
                            // video_link: "Y345kHrA2dI",
                            // start_on: startTimeIST, // ✅ 4:00 PM IST
                            // end_on: endTimeIST,     // ✅ 5:00 PM IST
                            // completion_percentage: "100%",
                            // is_completed: "yes"
                            // timestamp: [
                            //     { time: "10:50", title: "Introduction" },
                            //     { time: "19:40", title: "Nail structure" },
                            //     { time: "30:00", title: "Tools knowledge" },
                            //     { time: "01:00:54", title: "Nail Shapes" },
                            //     { time: "01:06:32", title: "Dry Manicure" },
                            //     { time: "01:24:53", title: "Q & A session" }
                            // ]




                        }
                        : lesson
                );

                // ✅ Step 5: Update Firestore for each user
                await updateDoc(courseRef, { lessons: updatedLessons });
                updatedCount++;
            }

            setLoading(false);
            Swal.fire("Success", `Updated lesson times for ${updatedCount} users!`, "success");

        } catch (error) {
            console.error("Error updating lesson times:", error);
            setLoading(false);
            Swal.fire("Error", "Failed to update lesson times!", "error");
        }
    };

    return (
        <div className="container mt-5">
            <h3>Update Course Lesson Timing</h3>
            <p><strong>Course:</strong> Hair Color Basics: Trends & Techniques</p>
            <p><strong>Lesson:</strong> Hair Color Fundamentals</p>
            <p><strong>New Start Time:</strong> 4:00 PM (Feb 21, 2025) IST</p>
            <p><strong>New End Time:</strong> 5:00 PM (Feb 21, 2025) IST</p>

            <button className="btn btn-primary" onClick={updateLessonTimes} disabled={loading}>
                {loading ? "Updating..." : "Update Lesson Time"}
            </button>
        </div>
    );
};

export default UpdateCourse;



// // // // import React, { useState } from "react";
// // // // import { collection, addDoc } from "firebase/firestore";
// // // // import db from "./Firebase";
// // // // import Swal from "sweetalert2";

// // // // const users_data = ["7838850069",]; // ✅ List of Users

// // // // const courseData = {
// // // //     "all_course_notes": "yes",
// // // //     "all_course_notes_link": "https://drive.google.com/file/d/16KqaNEVfDpnIfXoH3E5uJZp4e7teAQ2s/view?usp=drive_link",
// // // //     "content_description": "5 Live Classes",
// // // //     "course_categories": "Beauty Basics",
// // // //     "course_description": "In this course, you'll delve into the science of hair coloring, understanding how different agents interact with hair structure. We'll explore the latest trends for 2025 and teach you various application methods, including balayage and traditional highlights, to achieve both subtle and dramatic effects. Additionally, you'll learn to assess clients features to recommend personalized color choices and understand essential maintenance practices to keep hair vibrant and healthy.",
// // // //     "course_end_date": "2025-02-21",
// // // //     "course_expert_name": "Yogi Hair Guru",
// // // //     "course_id": "006",
// // // //     "course_image": "https://firebasestorage.googleapis.com/v0/b/youvati.appspot.com/o/files%2FHair%20course%202.webp?alt=media&token=789de4b3-5575-4462-b831-42e28bff3679",
// // // //     "course_language": "Hindi/English",
// // // //     "course_length": "7 hr 30 mins / 5 Days",
// // // //     "course_name": "Hair Color Basics: Trends & Techniques",
// // // //     "course_price": {
// // // //         "actual_price": 499,
// // // //         "membership_price": 399
// // // //     },
// // // //     "course_start_date": "2025-02-17",
// // // //     "course_tag": "Beauty Basics",
// // // //     "course_type": "Live",
// // // //     "created_date": new Date("2025-01-23T16:49:05Z"),
// // // //     "demo_video_url": "3EgSoRGGI48",
// // // //     "enrolled_date": new Date(),
// // // //     "expert_id": "e2",
// // // //     "expert_image_url": "https://firebasestorage.googleapis.com/v0/b/youvati.appspot.com/o/files%2FYogi%20Cutout.jpg?alt=media&token=fff5caba-5bf1-432b-a742-55ea495ba207",
// // // //     "is_certificate": "yes",
// // // //     "is_demo_video": "yes",
// // // //     "is_doubt_clearing_session": "no",
// // // //     "is_pdfnotes": "yes",
// // // //     "is_quiz": "true",
// // // //     "is_recording": "yes",
// // // //     "is_whatsappgroup": "yes",
// // // //     "lessons": [
// // // //         {
// // // //             "completion_percentage": "0%",
// // // //             "description": "We'll explore the essential principles of hair coloring, including the science of color theory, the structure of hair, and the interaction between different hair types and coloring techniques.",
// // // //             "end_on": new Date("2025-02-17T17:00:00Z"),
// // // //             "is_completed": "no",
// // // //             "is_file": "no",
// // // //             "is_online": "yes",
// // // //             "is_video": "no",
// // // //             "lesson": "Hair Color Fundamentals",
// // // //             "notes": "",
// // // //             "sequence": "1",
// // // //             "start_on": new Date("2025-02-17T15:00:00Z"),
// // // //             "time": "",
// // // //             "timestamp": [],
// // // //             "title": "Class 1",
// // // //             "video_link": "",
// // // //             "worksheet": "",
// // // //             "zoom_date_time": "",
// // // //             "zoom_link": "https://us06web.zoom.us/j/84907693318?pwd=FndCSF6lVp4afcRhSQK0DZbGIxx0CG.1"
// // // //         },
// // // //         {
// // // //             "completion_percentage": "0%",
// // // //             "description": "We will learn the art of achieving the perfect ombré effect. This class includes a live demonstration showcasing the seamless transition from darker roots to lighter ends, a hallmark of the ombré style.",
// // // //             "end_on": new Date("2025-02-18T17:00:00Z"),
// // // //             "is_completed": "no",
// // // //             "is_file": "no",
// // // //             "is_online": "yes",
// // // //             "is_video": "no",
// // // //             "lesson": "Demo of Ombre Color",
// // // //             "notes": "",
// // // //             "sequence": "2",
// // // //             "start_on": new Date("2025-02-18T15:00:00Z"),
// // // //             "time": "",
// // // //             "timestamp": [],
// // // //             "title": "Class 2",
// // // //             "video_link": "",
// // // //             "worksheet": "",
// // // //             "zoom_date_time": "",
// // // //             "zoom_link": "https://us06web.zoom.us/j/84907693318?pwd=FndCSF6lVp4afcRhSQK0DZbGIxx0CG.1"
// // // //         },
// // // //         {
// // // //             "completion_percentage": "0%",
// // // //             "description": "This class will cover essential topics such as understanding the color wheel, identifying different hair textures and their impact on color application, and mastering the art of formulating and applying hair color.",
// // // //             "end_on": new Date("2025-02-19T17:00:00Z"),
// // // //             "is_completed": "no",
// // // //             "is_file": "no",
// // // //             "is_online": "yes",
// // // //             "is_video": "no",
// // // //             "lesson": "Hair Color Fundamentals Part 2",
// // // //             "notes": "",
// // // //             "sequence": "3",
// // // //             "start_on": new Date("2025-02-19T15:00:00Z"),
// // // //             "time": "",
// // // //             "timestamp": [],
// // // //             "title": "Class 3",
// // // //             "video_link": "",
// // // //             "worksheet": "",
// // // //             "zoom_date_time": "",
// // // //             "zoom_link": "https://us06web.zoom.us/j/84907693318?pwd=FndCSF6lVp4afcRhSQK0DZbGIxx0CG.1"
// // // //         },
// // // //         {
// // // //             "completion_percentage": "0%",
// // // //             "description": "Demonstration of the latest techniques in hair highlights, focusing on creating vibrant, multi-dimensional looks that cater to current trends.",
// // // //             "end_on": new Date("2025-02-20T17:00:00Z"),
// // // //             "is_completed": "no",
// // // //             "is_file": "no",
// // // //             "is_online": "yes",
// // // //             "is_video": "no",
// // // //             "lesson": "Demo of Trendy Techniques of Hair Highlights",
// // // //             "notes": "",
// // // //             "sequence": "4",
// // // //             "start_on": new Date("2025-02-20T15:00:00Z"),
// // // //             "time": "",
// // // //             "timestamp": [],
// // // //             "title": "Class 4",
// // // //             "video_link": "",
// // // //             "worksheet": "",
// // // //             "zoom_date_time": "",
// // // //             "zoom_link": "https://us06web.zoom.us/j/84907693318?pwd=FndCSF6lVp4afcRhSQK0DZbGIxx0CG.1"
// // // //         },
// // // //         {
// // // //             "completion_percentage": "0%",
// // // //             "description": "We will recap the key concepts covered so far and provide an opportunity for users to engage directly with our expert.",
// // // //             "end_on": new Date("2025-02-21T17:00:00Z"),
// // // //             "is_completed": "no",
// // // //             "is_file": "no",
// // // //             "is_online": "yes",
// // // //             "is_video": "no",
// // // //             "lesson": "Course Recap and Q & A with Expert",
// // // //             "notes": "",
// // // //             "sequence": "5",
// // // //             "start_on": new Date("2025-02-21T15:00:00Z"),
// // // //             "time": "",
// // // //             "timestamp": [],
// // // //             "title": "Class 5",
// // // //             "video_link": "",
// // // //             "worksheet": "https://drive.google.com/file/d/1AjtZSoC8K4k51WUA5VZpsWQCrcHmB_tX/view?usp=drive_link",
// // // //             "zoom_date_time": "",
// // // //             "zoom_link": "https://us06web.zoom.us/j/84907693318?pwd=FndCSF6lVp4afcRhSQK0DZbGIxx0CG.1"
// // // //         }
// // // //     ],
// // // //     "overall_completion_percentage": 98,
// // // //     "passing_marks": 6,
// // // //     "quiz_id": "02",
// // // //     "registered_date": new Date(),
// // // //     "total_quiz_questions": 10,
// // // //     "updated_date": new Date()
// // // // };



// // // // const EnrollUsers = () => {
// // // //     const [loading, setLoading] = useState(false);

// // // //     const enrollUsers = async () => {
// // // //         setLoading(true);
// // // //         let successCount = 0;
// // // //         let failureCount = 0;

// // // //         for (const phone_no of users_data) {
// // // //             try {
// // // //                 await addDoc(collection(db, "nv_enrolled_courses"), {
// // // //                     ...courseData,
// // // //                     phone_no: phone_no, // ✅ Assign **each** phone number dynamically
// // // //                 });
// // // //                 successCount++;
// // // //             } catch (error) {
// // // //                 console.error(`Error enrolling ${phone_no}:`, error);
// // // //                 failureCount++;
// // // //             }
// // // //         }

// // // //         setLoading(false);

// // // //         // ✅ Show success/failure message
// // // //         Swal.fire({
// // // //             title: "Enrollment Completed",
// // // //             text: `✅ Successful: ${successCount} | ❌ Failed: ${failureCount}`,
// // // //             icon: "info",
// // // //         });
// // // //     };

// // // //     return (
// // // //         <div className="container mt-5">
// // // //             <h3>Enroll Users in Course</h3>
// // // //             <p><strong>Course:</strong> {courseData.course_name || "N/A"}</p>
// // // //             <p><strong>Instructor:</strong> {courseData.course_expert_name || "N/A"}</p>
// // // //             <p><strong>Start Date:</strong> {courseData.course_start_date || "N/A"}</p>
// // // //             <p><strong>Duration:</strong> {courseData.course_length || "N/A"}</p>

// // // //             <button className="btn btn-primary" onClick={enrollUsers} disabled={loading}>
// // // //                 {loading ? "Enrolling..." : "Enroll Users"}
// // // //             </button>
// // // //         </div>
// // // //     );
// // // // };

// // // // export default EnrollUsers;




// import React, { useState } from "react";
// import { collection, query, where, getDocs, updateDoc, doc } from "firebase/firestore";
// import db from "./Firebase";
// import Swal from "sweetalert2";
// import moment from "moment-timezone";

// const UpdateCourse = () => {
//     const [loading, setLoading] = useState(false);

//     const updateLessonTimes = async () => {
//         setLoading(true);

//         try {
//             // ✅ Step 1: Find all users enrolled in the course
//             const q = query(collection(db, "nv_enrolled_courses"), where("course_name", "==", "Hair Color Basics: Trends & Techniques"));
//             const querySnapshot = await getDocs(q);

//             if (querySnapshot.empty) {
//                 Swal.fire("Error", "No enrolled users found for this course!", "error");
//                 setLoading(false);
//                 return;
//             }

//             let updatedCount = 0;

//             // ✅ Step 2: Loop through all enrolled users
//             for (const courseDoc of querySnapshot.docs) {
//                 const courseRef = doc(db, "nv_enrolled_courses", courseDoc.id);
//                 const courseData = courseDoc.data();

//                 // ✅ Step 3: Convert IST time correctly
//                 const startTimeIST = moment.tz("2025-02-21 15:00:00", "Asia/Kolkata").toDate(); // ✅ 4:00 PM IST
//                 const endTimeIST = moment.tz("2025-02-21 17:00:00", "Asia/Kolkata").toDate();   // ✅ 5:00 PM IST

//                 // ✅ Step 4: Update only the first lesson's start_on & end_on
//                 const updatedLessons = courseData.lessons.map((lesson, index) =>
//                     index === 4
//                         ? {
//                             ...lesson,
//                             video_link: "oN83fBnEt9Y"
//                             // start_on: startTimeIST, // ✅ 4:00 PM IST
//                             // end_on: endTimeIST,     // ✅ 5:00 PM IST
//                         }
//                         : lesson
//                 );

//                 // ✅ Step 5: Update Firestore for each user
//                 await updateDoc(courseRef, { lessons: updatedLessons });
//                 updatedCount++;
//             }

//             setLoading(false);
//             Swal.fire("Success", `Updated lesson times for ${updatedCount} enrolled users!`, "success");

//         } catch (error) {
//             console.error("Error updating lesson times:", error);
//             setLoading(false);
//             Swal.fire("Error", "Failed to update lesson times!", "error");
//         }
//     };

//     return (
//         <div className="container mt-5">
//             <h3>Update Course Lesson Timing</h3>
//             <p><strong>Course:</strong> Hair Color Basics: Trends & Techniques</p>
//             <p><strong>Lesson:</strong> Hair Color Fundamentals</p>
//             <p><strong>New Start Time:</strong> 3:00 PM (Feb 17, 2025) IST</p>
//             <p><strong>New End Time:</strong> 5:00 PM (Feb 17, 2025) IST</p>

//             <button className="btn btn-primary" onClick={updateLessonTimes} disabled={loading}>
//                 {loading ? "Updating..." : "Update Lesson Time"}
//             </button>
//         </div>
//     );
// };

// export default UpdateCourse;

